export const getters = {
  menuList: state => state.menu.menuList,
  isCollapsed: state => state.menu.isCollapsed,
  permissionList: state => state.permission.permissionList,
  staff: state => state.staff.staff,
  tagList: state => state.tag.tagList,
  token: state => state.token.token
}
